<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <vet-service-form
    v-else
    :initVetService="initVetService"
    :successMsg="t('created')"
    :submitAction="submit"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import VetServiceForm from '@/views/vetServices/VetServiceForm.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

import VetService from '@/models/VetService'
import Pet from '@/models/Pet'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-vet-service',

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          created: 'Vet service was created successfully'
        },
        ar: {
          created: 'تم إنشاء الخدمة البيطرية بنجاح'
        }
      }
    })

    return { t }
  },

  components: {
    VetServiceForm,
    LoadingSpinner
  },

  data() {
    return {
      initVetService: new VetService(),
      loading: false
    }
  },

  async beforeMount() {
    // Check if petId is passed in query params
    const petId = this.$route.query.petId as string
    if (petId) {
      this.loading = true
      try {
        const petResp = await this.$http.get<Pet>(`${Pet.ENDPOINT}/${petId}`)
        const pet = Pet.from(petResp)
        this.initVetService.petID = pet.id
        this.initVetService.pet = pet
        this.initVetService.customerID = pet.customerID
      } catch (error) {
        console.error('Failed to load pet:', error)
      }
      this.loading = false
    }
  },

  methods: {
    async submit(vetService: VetService) {
      try {
        const createdVetService = await this.$http.post<VetService>(VetService.ENDPOINT, vetService)
        await this.$router.push(this.$Route.VET_SERVICES)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
